function createElementFromHTML(htmlString) {
    let div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
}

function createNodesFromHTML(htmlString) {
    let template = document.createElement('template');
    template.innerHTML = htmlString;

    return template.content.childNodes;
}

function setHeight(el, val) {
    if (typeof val === "function") val = val();
    if (typeof val === "string") el.style.height = val;
    else el.style.height = val + "px";
}


let equalheight = function(container){
    let currentTallest = 0,
        currentRowStart = 0,
        rowDivs = [],
        topPostion  = 0;

    Array.from(container).forEach((el,i) => {
        el.style.height = "auto";
        topPostion = el.offsetTop;
        if(currentRowStart != topPostion){
            for (let currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                setHeight(rowDivs[currentDiv], currentTallest)
            }
            rowDivs.length = 0;
            currentRowStart = topPostion;
            currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
            rowDivs.push(el);
        } else {
            rowDivs.push(el);
            currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
        }
        for (let currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            setHeight(rowDivs[currentDiv], currentTallest)
        }
    })
}

export { createElementFromHTML, createNodesFromHTML, equalheight };
